// @flow
import React from 'react';
import { FRONT_END_DISPLAY_NAMES } from '@streaming-projects/enums';
import { SPTableFlowWorkloadEnabledContainer } from '@streaming-projects/workloads/tableflow-workloads/enable/SPTableFlowWorkloadEnabledContainer';

export const SPTableFlowWorkloadEnabledCellRenderer = (props) => {
  if (props.value == null) {
    return null;
  }

  const tableFlowWorkloadId = props.data[FRONT_END_DISPLAY_NAMES.WORKLOAD_ID];
  const tableFlowResourceId = props.data[FRONT_END_DISPLAY_NAMES.RESOURCE_ID];

  return (
    <SPTableFlowWorkloadEnabledContainer
      addLabel={false}
      checked={props.value}
      tableFlowResourceId={tableFlowResourceId}
      tableFlowWorkloadId={tableFlowWorkloadId}
    />
  );
};
